const ANNOTATION_INFRACOST_PROJECT = "infracost/project";

export { ANNOTATION_INFRACOST_PROJECT };
//# sourceMappingURL=annotations.esm.js.map
